export default {
  title: 'Profiel',
  fields: {
    name: {
      label: 'Naam',
      placeholder: 'Voer restaurantnaam in',
    },
    short_name: {
      label: 'Korte naam',
      placeholder: 'Voer korte restaurantnaam in',
      tooltip:
        'Restaurantnamen zijn soms erg lang en kunnen aanvullende informatie bevatten. In sommige gevallen (bijv. voor kortere meldingen) is een kortere versie van de naam vereist',
    },
    phone_number: {
      label: 'Telefoonnummer',
      placeholder: 'Voer restauranttelefoon in',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Voer restaurant-e-mail in',
    },
    slug: {
      label: 'Slug',
      placeholder: 'Merk-slug',
    },
    language: {
      label: 'Taal',
      placeholder: 'Groepstandaard gebruiken',
      tooltip:
        'De taal die klanten zien op de webshop van dit restaurant, en de standaardtaal voor het personeel. Laat leeg om de taal van het merk te volgen. Personeel kan nog steeds een eigen taal kiezen voor hun eigen weergave.',
    },
    sms_name: {
      label: 'SMS-naam',
      placeholder: 'SMS-weergavenaam',
    },
    instagram_link: {
      label: 'Instagram-link',
      placeholder: 'Voer Instagram-link restaurant in',
    },
    website_link: {
      label: 'Website-link',
      placeholder: 'Voer restaurant-websitelink in',
    },
    impressum_link: {
      label: 'Impressum-link',
      placeholder: 'Voer restaurant impressum-link in',
    },
    timezone: {
      label: 'Tijdzone',
      placeholder: 'Zoek naar een stad of tijdzone',
      tooltip:
        'De tijdzone waarin dit restaurant actief is. Het bepaalt de tijdstempels van bestellingen, openingstijden en geplande bestelslots. Deze is ingesteld op basis van het adres van het restaurant bij aanmaak — corrigeer het hier indien onjuist.',
    },
    time_format: {
      label: 'Tijdnotatie',
      placeholder: 'Landstandaard gebruiken',
      tooltip:
        'Hoe tijden worden weergegeven aan uw team, in het dashboard en het bestellingenportaal. Laat leeg om de conventie van de regio van het restaurant te volgen.',
      options: {
        '12h': '12-uurs (5:30 pm)',
        '24h': '24-uurs (17:30)',
      },
    },
    primary_color: {
      label: 'Hoofdkleur',
    },
    restaurant_type: {
      label: 'Restauranttype & servicemodel',
    },
    cuisine_types: {
      label: 'Voedselcategorieën & keukentypen',
    },
  },
  test_restaurant: {
    title: 'Testrestaurant',
    description:
      'Maak dit uw testrestaurant om printen, e-mails, bestellingen en integraties in productie te proberen. Het blijft werken als elk ander restaurant en wordt nooit gefactureerd. U kunt één testrestaurant hebben.',
    description_test:
      "Dit is uw testrestaurant. Het werkt als elk ander restaurant en wordt nooit gefactureerd. Klant-e-mails en sms'jes over zijn bestellingen beginnen met [TEST].",
    mark: 'Markeren als testrestaurant',
    remove: 'Testmarkering verwijderen',
    slot_taken:
      'U heeft al een testrestaurant ({{name}}). Verwijder eerst de testmarkering van uw bestaande restaurant.',
  },
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    info_updated: 'Instellingen succesvol bijgewerkt',
  },
};
